module.exports = __webpack_public_path__ + "img/互动贴纸--个性定制.8667d376.png";